module.exports = __webpack_public_path__ + "static/media/disconnect.4b1b2064.png";